import React from 'react';

import type { CouponStatus } from 'js/src/client';
import Callout, { CALLOUT_TYPES } from 'js/src/components/common/ui/Callout';

export function CouponNode(props: { couponStatus: CouponStatus | null }) {
    if (props.couponStatus === null || props.couponStatus.valid === undefined) {
        return null;
    }
    if (props.couponStatus.valid) {
        return (
            <Callout
                className="mt-l5-12"
                msgType={CALLOUT_TYPES.INFO}
                title="Discount successfully applied!"
                text={`${props.couponStatus.id} gives you ${props.couponStatus.discount} off ${props.couponStatus.duration}`}
            />
        );
    } else {
        return (
            <Callout
                className="mt-l5-12"
                msgType={CALLOUT_TYPES.ERROR}
                text={`Discount ${props.couponStatus.id} is not valid`}
            />
        );
    }
}
